import React, { Component } from 'react'
import i18n from '../i18n.json'

class Success extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      userLocation: null
    }
  }

  componentDidMount() {
    if (this.state.userLocation) return
    let url = 'https://freegeoip.net/json/'
    fetch(url)
    .then((response) => response.json())
    .then((responseJson) => {
      let { country_code } = responseJson
      if (country_code) {
        if (country_code === 'BR')
          this.props.updateLanguage('pt')
        else
          this.props.updateLanguage('en')
        this.setState({
          userLocation: country_code
        })
      }
    })
    .catch((error) => {
      // console.error(error)
    })
  }

  render() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    if (!selectedLanguage) selectedLanguage = 'en'
    // let brandId = this.props.match.params.id
    return (
      <div id="success-bg">
        <div className="right-box">
          <h1>{ i18n[selectedLanguage]['success-congrats'] }</h1>
          <p>
            { i18n[selectedLanguage]['success-title'] }
            <br /><br />
            { i18n[selectedLanguage]['success-description'] }
            <br /><br />
            <a href="/dashboard">
            <i className="fa fa-arrow-circle-o-down user-icon"></i>
            { i18n[selectedLanguage]['success-link'] }
            </a>
          </p>
        </div>
      </div>
    )
  }
}

export default Success



// WEBPACK FOOTER //
// ./src/components/Success.js